/*
	Generated on 29/04/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.9.0
*/
import React from 'react';
import { Link, useNavigate } from "react-router";
import { useParams } from "@/commons/hooks/useParams"

import { useAuth } from '@/commons/auth';
import { Button, Modal,Spinner } from '@/commons/components';
import { useCookies } from 'react-cookie';

import * as Layouts from "@/commons/layouts";

const StudiTable = ({ programStudiDataList,
		 

	}) => {
  const { checkPermission } = useAuth();
  const [cookies, setCookie] = useCookies(['selectedProdi']);

  
  
  
  	const {  } = useParams();
  
  
  return (
  <>
    <Layouts.ListComponentTableLayout
  	  items={[programStudiDataList]}
  	  itemsAttrs={[
          {
            id: "namaProgramStudi",
            condition: "",
            label: "Nama Program Studi",
  		  featureName: "nama",
            editable: false
          }
  ]}
        itemsEvents={(studiItem) => [
          
          <Link to='/'>
            <Button
              size="sm"
              variant=
                          "secondary"
                          onClick={() => {
                            setCookie('selectedProdi', studiItem.id, { path: '/' });
                          }}
            >
              Pilih
            </Button>
          </Link>
          
          
        ]}
        itemsModals={(kuliahItem) => [
        ]}
  	/>
  </>
  )
};

export default StudiTable;
